export const invoiceList = [
  {
    key: "1",
    invoiceId: "#1254058",
    client: "NovaWave LLC",
    project: "Truelysell",
    dueDate: "21 May 2024",
    img: "assets/img/icons/company-icon-01.svg",
    img1: "assets/img/priority/truellysel.svg",
    amount: "$2,15,000",
    paidAmount: "$2,15,000",
    balanceAmount: "$0",
    status: "Partially Paid",
  },
  {
    key: "2",
    invoiceId: "#1254057",
    client: "BlueSky Industries",
    project: "Dreamschat",
    dueDate: "19 Oct 2023",
    amount: "$1,45,000",
    img: "assets/img/icons/company-icon-02.svg",
    img1: "assets/img/priority/project-01.svg",
    paidAmount: "$1,45,000",
    balanceAmount: "$0",
    status: "Paid",
  },
  {
    key: "3",
    invoiceId: "#1254056",
    client: "Silver Hawk",
    project: "Truelysell",
    dueDate: "24 Oct 2023",
    amount: "$2,15,000",
    img: "assets/img/icons/company-icon-03.svg",
    img1: "assets/img/priority/dreamchat.svg",
    paidAmount: "$1,00,000",
    balanceAmount: "$1,15,000",
    status: "Partially Paid",
  },
  {
    key: "4",
    invoiceId: "#1254055",
    client: "Summit Peak",
    project: "Servbook",
    dueDate: "10 Nov 2023",
    amount: "$4,80,380",
    img: "assets/img/icons/company-icon-04.svg",
    img1: "assets/img/priority/truellysell.svg",
    paidAmount: "$4,80,380",
    balanceAmount: "$0",
    status: "Paid",
  },
  {
    key: "5",
    invoiceId: "#1254054",
    client: "RiverStone Ventur",
    project: "DreamPOS",
    dueDate: "18 Nov 2023",
    amount: "$2,12,000",
    img: "assets/img/icons/company-icon-05.svg",
    img1: "assets/img/priority/servbook.svg",
    paidAmount: "$0",
    balanceAmount: "$2,12,000",
    status: "Unpaid",
  },
  {
    key: "6",
    invoiceId: "#1254053",
    client: "CoastalStar Co.",
    project: "Kofejob",
    dueDate: "20 Nov 2023",
    amount: "$3,50,000",
    img: "assets/img/icons/company-icon-07.svg",
    img1: "assets/img/icons/company-icon-05.svg",
    paidAmount: "$1,50,000",
    balanceAmount: "$2,00,000",
    status: "Partially Paid",
  },
  {
    key: "7",
    invoiceId: "#1254052",
    client: "HarborView",
    project: "Doccure",
    dueDate: "07 Dec 2023",
    amount: "$1,23,000",
    img: "assets/img/icons/company-icon-08.svg",
    img1: "assets/img/icons/company-icon-07.svg",
    paidAmount: "$1,23,000",
    balanceAmount: "$1,23,000",
    status: "Overdue",
  },
  {
    key: "8",
    invoiceId: "#1254051",
    client: "Golden Gate Ltd",
    project: "Best@laundry",
    dueDate: "14 Dec 2023",
    amount: "$3,12,500",
    img: "assets/img/icons/company-icon-09.svg",
    img1: "assets/img/priority/project-02.svg",
    paidAmount: "$3,12,500",
    balanceAmount: "$0",
    status: "Paid",
  },
  {
    key: "9",
    invoiceId: "#1254050",
    client: "Redwood Inc",
    project: "Dreamsports",
    dueDate: "22 Dec 2023",
    amount: "$4,18,000",
    img: "assets/img/icons/company-icon-10.svg",
    img1: "assets/img/priority/best.svg",
    paidAmount: "$0",
    balanceAmount: "$4,18,000",
    status: "Unpaid",
  },
  {
    key: "10",
    invoiceId: "#1254049",
    client: "NovaWave LLC",
    project: "Truelysell",
    dueDate: "28 Dec 2023",
    amount: "$5,00,000",
    img: "assets/img/icons/company-icon-01.svg",
    img1: "assets/img/priority/truellysel.svg",
    paidAmount: "$5,00,000",
    balanceAmount: "$0",
    status: "Paid",
  },
];
